import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppEnvironmentService } from '../app-environment.service';
// import { environment } from 'environments/environment';
import { UserSessionService } from '../user-session/user-session.service';
import { environment } from '../../../../environments/environment';

@Injectable(
)
export class RequestFormatterInterceptor implements HttpInterceptor {
  // private appEnv: AppEnvironmentService = inject(AppEnvironmentService);
  private userSessionService = inject(UserSessionService);
  private static serviceUrls: string[];

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const userSession = this.userSessionService; //. this.appEnv.userSession;
    if (this.isServiceUrl(req.url)) {
      let header = req.headers;
      let requestId = "Pre-Login";

      //** update when user token implementation details are available */

      if (userSession?.isSessionActive) {
        header = header.set('Authorization', 'Bearer ' + userSession.securityToken);
        if (userSession.sessionId) {
          requestId = userSession.sessionId;
        }
        else {
          requestId = "Login_" + (new Date()).toISOString();
        }
      }

      header = header.set("RequestId", requestId);
      req = req.clone({ headers: header });
    }
    return next.handle(req).pipe(map((event: HttpEvent<any>) => {
      return event;
    }));
  }

  private isServiceUrl(url: string) {
    if (!RequestFormatterInterceptor.serviceUrls) {
      const serviceUrls = <string[]>[];
      serviceUrls.push(environment.configServiceUrl);
      serviceUrls.push(environment.tmsServiceUrl);
      serviceUrls.push(environment.communicationsUrl);
      RequestFormatterInterceptor.serviceUrls = serviceUrls;
    }
    if (url) {
      for (let serviceUrl of RequestFormatterInterceptor.serviceUrls) {
        if (url.startsWith(serviceUrl)) {
          return true;
        }
      }
    }

    return false; //  did not match with any service url
  }
}

const serviceUrls = <string[]>[];

function isServiceUrl(url: string): boolean {
  if (serviceUrls.length === 0) {
    const urls = [
      environment.configServiceUrl,
      environment.tmsServiceUrl,
      environment.communicationsUrl,
      environment.trainingServiceUrl,
      environment.logReporterServiceUrl,
      environment.AnandadharaServiceUrl,
      environment.loggingServiceUrl,
    ];
    for (const u of urls) {
      if (u) {
        serviceUrls.push(u);
      }
    }
  }
  if (url) {
    for (const serviceUrl of serviceUrls) {
      if (url.startsWith(serviceUrl)) {
        return true;
      }
    }
  }

  return false;
}


export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  const userSession = inject(UserSessionService);

  let header = req.headers;

  const isAnandadhara = req.url.includes('anandadhara.wb.gov.in');

  //Note: Anandadhara API
  if (isAnandadhara) {

    header = header
      .set('X-ANANDADHARA-KEY', 'f07d51fef6a4858330c23b28148f0ef45d83e7440dfaeb64cb9cd8');

    // // ❌ Do NOT send these
    // header = header.delete('Authorization');
    // header = header.delete('RequestId');
  } else if (isServiceUrl(req.url)) {
    let requestId = "AppPrelogin";

    if (userSession?.isSessionActive) {

      header = header.set('Authorization', 'Bearer ' + userSession.securityToken);

      requestId = userSession.sessionId
        ? userSession.sessionId
        : "Login_" + new Date().toISOString();
    }

    header = header.set("RequestId", requestId);
  }

  req = req.clone({ headers: header });

  return next(req);
}

// export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
//   // const appEnv = inject(AppEnvironmentService);
//   const userSession = inject(UserSessionService) //. this.appEnv.userSession;
//   if (isServiceUrl(req.url)) {
//     let header = req.headers;
//     let requestId = "AppPrelogin";

//     //** update when user token implementation details are available */

//     if (userSession?.isSessionActive) {
//       header = header.set('Authorization', 'Bearer ' + userSession.securityToken);
//       if (userSession.sessionId) {
//         requestId = userSession.sessionId;
//       }
//       else {
//         requestId = "Login_" + (new Date()).toISOString();
//       }
//     }

//     header = header.set("RequestId", requestId);
//     req = req.clone({ headers: header });
//   }
//   return next(req);
//   // return next.handle(req).pipe(map((event: HttpEvent<any>) => {
//   //   return event;
//   // }));
// }




// export class RequestFormatterInterceptor implements HttpInterceptor {
//   // private appEnv: AppEnvironmentService = inject(AppEnvironmentService);
//   private userSessionService = inject(UserSessionService);
//   private static serviceUrls: string[];

//   constructor(private appEnv: AppEnvironmentService) {
//   }

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//     const userSession = this.userSessionService; //. this.appEnv.userSession;
//     if (this.isServiceUrl(req.url)) {
//       let header = req.headers;
//       let requestId = "Pre-Login";

//       //** update when user token implementation details are available */

//       if (userSession?.isSessionActive) {
//         header = header.set('Authorization', 'Bearer ' + userSession.securityToken);
//         if (userSession.sessionId) {
//           requestId = userSession.sessionId;
//         }
//         else {
//           requestId = "Login_" + (new Date()).toISOString();
//         }
//       }

//       header = header.set("RequestId", requestId);
//       req = req.clone({ headers: header });
//     }
//     return next.handle(req).pipe(map((event: HttpEvent<any>) => {
//       return event;
//     }));
//   }

//   private isServiceUrl(url: string) {
//     if (!RequestFormatterInterceptor.serviceUrls) {
//       const serviceUrls = <string[]>[];
//       serviceUrls.push(environment.configServiceUrl);
//       serviceUrls.push(environment.tmsServiceUrl);
//       serviceUrls.push(environment.communicationsUrl);
//       RequestFormatterInterceptor.serviceUrls = serviceUrls;
//     }
//     if (url) {
//       for (let serviceUrl of RequestFormatterInterceptor.serviceUrls) {
//         if (url.startsWith(serviceUrl)) {
//           return true;
//         }
//       }
//     }

//     return false; //  did not match with any service url
//   }
// }

// const serviceUrls = <string[]>[];
// function isServiceUrl(url: string) {
//   if (serviceUrls.length == 0) {
//     serviceUrls.push(environment.configServiceUrl);
//     serviceUrls.push(environment.tmsServiceUrl);
//     serviceUrls.push(environment.communicationsUrl);
//   }
//   if (url) {
//     for (let serviceUrl of serviceUrls) {
//       if (url.startsWith(serviceUrl)) {
//         return true;
//       }
//     }
//   }

//   return false; //  did not match with any service url
// }

// export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
//   const appEnv = inject(AppEnvironmentService);
//   const userSession = inject(UserSessionService);
//   if (isServiceUrl(req.url)) {
//     let header = req.headers;
//     let requestId = "AppPrelogin";

//     //** update when user token implementation details are available */

//     if (userSession?.isSessionActive) {
//       header = header.set('Authorization', 'Bearer ' + userSession.securityToken);
//       if (userSession.sessionId) {
//         requestId = userSession.sessionId;
//       }
//       else {
//         requestId = "Login_" + (new Date()).toISOString();
//       }
//     }

//     header = header.set("RequestId", requestId);
//     header = header.set('Content-Type', 'application/json');
//     // if (isServiceUrl(req.url) && !req.url.includes('/Login')) {
//     //   const encryptedBody = encryptRequestBody(req.body, userSession);
//     //   header.delete('Content-Type');
//     //   req = req.clone({
//     //     headers: header.set('Content-Type', 'text/plain'),
//     //     body: encryptedBody,
//     //     responseType: 'text' as 'json'
//     //   });

//     // } else 
//     {
//       req = req.clone({ headers: header });
//     }
//   }

//   return next(req)
//   // .pipe(
//   //   map((event: HttpEvent<any>) => {
//   //     if (event instanceof HttpResponse && isServiceUrl(req.url) && !req.url.includes('/Login')) {
//   //       const rawBody = event.body;

//   //       if (!rawBody || typeof rawBody !== 'string') {
//   //         return event;
//   //       }
//   //       const decrypted = tryDecrypt(rawBody)
//   //       let parsed;
//   //       try {
//   //         parsed = typeof decrypted === 'string' ? JSON.parse(decrypted) : decrypted;
//   //       } catch {
//   //         parsed = decrypted;
//   //       }
//   //       return event.clone({ body: parsed });
//   //     }
//   //     return event;
//   //   })
//   // );




// }

// function tryDecrypt(encryptedBase64: string): any {
//   const key = CryptoJS.enc.Utf8.parse('gInVji1xPWmtH3DaRFGlnydwGSbBpDFl');
//   const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

//   try {
//     const decryptedBytes = CryptoJS.AES.decrypt(encryptedBase64, key, {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7
//     });

//     const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

//     if (!decryptedText) {
//       return encryptedBase64;
//     }

//     try {
//       const parsed = JSON.parse(decryptedText);
//       return parsed;
//     } catch (jsonErr) {
//       return decryptedText;
//     }

//   } catch (e) {
//     return encryptedBase64;
//   }
// }



// function encryptRequestBody(body: any, userSession: any): string {
//   const encryptionKey = environment.encryptionKey;
//   if (!encryptionKey) {
//     return typeof body === 'string' ? body : JSON.stringify(body);
//   }

//   // const encrypt = encryptKey(encryptionKey);
//   const sessionId = userSession.sessionId?.slice(18, 25);
//   const combinedKey_ = encryptionKey + sessionId;
//   const key = CryptoJS.SHA256(combinedKey_);
//   const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
//   const jsonString = typeof body === 'string' ? body : JSON.stringify(body);

//   const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });

//   return encrypted.toString();
// }

// // function encryptKey(encryptionKey: string) {
// //   const dynamicKey = encryptionKey;
// //   const secret = "sa@123";
// //   const encrypted = CryptoJS.AES.encrypt(dynamicKey, secret).toString();
// //   console.log("Encrypted:", encrypted);
// //   return encrypted;
// // }



